import { c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
/**
* @internal
*/
const _elementSizeObserver = _createElementSizeObserver();
function _createElementRectValueListener() {
	return { subscribe(element, subscriber) {
		let resizeObserver = new ResizeObserver(([entry]) => {
			subscriber({
				_contentRect: entry.contentRect,
				border: {
					width: entry.borderBoxSize[0].inlineSize,
					height: entry.borderBoxSize[0].blockSize
				},
				content: {
					width: entry.contentRect.width,
					height: entry.contentRect.height
				}
			});
		});
		return resizeObserver.observe(element), () => {
			resizeObserver.unobserve(element), resizeObserver.disconnect();
		};
	} };
}
function _createElementSizeObserver() {
	let disposeCache = /* @__PURE__ */ new WeakMap(), subscribersCache = /* @__PURE__ */ new WeakMap();
	return { subscribe(element, subscriber) {
		let subscribers = subscribersCache.get(element) || [], dispose = disposeCache.get(element);
		return subscribersCache.has(element) || (subscribersCache.set(element, subscribers), dispose = _createElementRectValueListener().subscribe(element, (elementRect) => {
			for (let sub of subscribers) sub(elementRect);
		})), subscribers.push(subscriber), () => {
			let idx = subscribers.indexOf(subscriber);
			idx > -1 && subscribers.splice(idx, 1), subscribers.length === 0 && dispose && dispose();
		};
	} };
}
/**
* Subscribe to the size of a DOM element.
* @beta
*/
function useElementSize(element) {
	let $ = c(3), [size, setSize] = useState(null), t0, t1;
	return $[0] === element ? (t0 = $[1], t1 = $[2]) : (t0 = () => {
		if (element) return _elementSizeObserver.subscribe(element, setSize);
	}, t1 = [element], $[0] = element, $[1] = t0, $[2] = t1), useEffect(t0, t1), size;
}
export { _elementSizeObserver as n, useElementSize as t };

//# sourceMappingURL=useElementSize-BJvbGHq8.js.map